import moment from 'moment';
import 'moment-timezone';
import { IndexedObject } from './general.types';


export class Comment {
  avatar: string;
  content: string;
  createdAt: string;
  id: number;
  isAuthorOwn: number;
  isLiked: boolean;
  parentId: null | number;
  totalLike: number;
  totalReply: number;
  updatedAt: string;
  userId: number;
  username: string;
  episodeId: number;

  constructor(data) {
    const { avatar, content, createdAt, id, isAuthorOwn, isLiked, parentId, totalLike, totalReply, updatedAt, userId, username, episodeId } = (data || {});
    this.avatar = avatar;
    this.content = content;
    this.createdAt = createdAt;
    this.id = id;
    this.isAuthorOwn = isAuthorOwn;
    this.isLiked = isLiked ? true : false;
    this.parentId = parentId;
    this.totalLike = totalLike;
    this.totalReply = totalReply;
    this.updatedAt = updatedAt;
    this.userId = userId;
    this.username = username;
    this.episodeId = episodeId;
  }

  get createdFromNow() {
    return moment.duration(
      moment.tz(
        moment.utc(this.createdAt).diff(moment()),
        moment.tz.guess(),
      ).valueOf()
    ).humanize(true);
  }

  set setIsLike(isLiked) {
    this.isLiked = isLiked;
    if (isLiked) this.totalLike ++;
    else this.totalLike --;
  }

  reload(data: IndexedObject) {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
    return this;
  }
}
  
export class Reply extends Comment {
  
};
